// Personeller listesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'personnel.list';

export const personnelListGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Personeller sayfası nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu sayfada şirketinizin personellerini görüntüler, ekler, siler ve yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    toolbar: t(`${G}.regions.toolbar`, 'Personel Oluştur ve ⋮ menüsü'),
    table: t(`${G}.regions.table`, 'Personel kartları / listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu sayfa ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Şirketinizin personellerini tek yerden görüntüler, yeni personel ekler, siler ve bilgilerini yönetirsiniz. Şube yöneticisi olarak girdiyseniz yalnız kendi şubenizin personelini görürsünüz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Personele mesaj göndermek için menüdeki Mesajlar sayfasını kullanın.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Personeli bulun'),
      text: t(`${G}.s2.text`, 'Filtre (huni) düğmesi arama ve filtre satırını açıp kapatır. Arama kutusuna personel adını yazın; Şube, Departman, Meslek / Ünvan, Rol ve Durum seçimleriyle listeyi daraltın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şube listesindeki "Şubesi Atanmamış" seçeneği, henüz bir şubeye bağlanmamış personeli gösterir.'),
        t(`${G}.s2.tip2`, 'Şube yöneticisi olarak girdiyseniz şube filtresi kendi şubenize kilitlidir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Personel ekleyin (QR ile kayıt)'),
      text: t(`${G}.s3.text`, '"Personel Oluştur" ile yeni bir personel kaydı açarsınız; isim, telefon ve e-posta bilgilerini girebilirsiniz. Personel uygulamaya kendisi kaydolduysa ⋮ menüsündeki "Yeni Ekle" ile onu personel ID\'si ile şirketinize eklersiniz.'),
      tips: [
        t(`${G}.s3.tip1`, '"Yeni Ekle" penceresinde "Tek Personel" ile tek tek, "Toplu Ekle" ile ID\'leri alt alta yazarak birden çok personel eklersiniz. "Galeriden QR Kod Tara" personel ID\'sini QR görselinden okur.'),
        t(`${G}.s3.tip2`, '⋮ menüsündeki "Şirket QR" ile şirketinize özel QR kod oluşturun; personelleriniz bu kodu okutarak kolayca kaydolur.'),
        t(`${G}.s3.tip3`, 'Silinen personeller listesindeyken ekleme düğmeleri kapalıdır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s4.title`, '4. Kart veya liste görünümünü seçin'),
      text: t(`${G}.s4.text`, '⋮ menüsündeki "Kart Görünümü" ve "Liste Görünümü" ile personeli kart ya da tablo şeklinde görürsünüz. Telefonda liste her zaman kart olarak gösterilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Menüde ayrıca Excel İndir, Departman Ekle, Mutfak Ekranı (yetkiniz varsa) ve Silinen Personeller / Aktif Personeller geçişi bulunur.'),
        t(`${G}.s4.tip2`, 'Tablo görünümünde Ad, Telefon, E-posta, Durum, Şube, Rol ve Bakiye sütunları yer alır; sütun başlığına tıklayarak sıralayabilirsiniz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Personeli yönetin: detay ve silme'),
      text: t(`${G}.s5.text`, 'Personel kartına veya tablo satırına tıklayınca Personel Ayrıntıları açılır. Buradan bilgileri düzenler, şube atamasını değiştirir veya kaldırır ve silme simgesiyle personeli sistemden kaldırırsınız.'),
      tips: [
        t(`${G}.s5.tip1`, 'Silinen personeller listesindeki kayıtlar açılmaz; aktif listeye dönmek için ⋮ menüsünden "Aktif Personeller"i seçin.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Durum işaretlerini okuyun'),
      text: t(`${G}.s6.text`, 'Her personelin görev durumu bir etiketle gösterilir. Böylece kimin boşta, kimin görevde olduğunu bir bakışta görürsünüz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Görevi Yok / Müsait: personele henüz görev atanmamış, yeni görev verebilirsiniz.'),
        t(`${G}.s6.tip2`, 'Görev Atanmış / Görevi Var (mavi): personel bir veya daha fazla göreve atanmış; kartta "Aktif görevleri var" yazar.'),
        t(`${G}.s6.tip3`, 'Rol etiketi: Admin kırmızı, Yönetici turuncu, Personel gri renktedir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar arasında gezin'),
      text: t(`${G}.s7.text`, 'Liste görünümünde kayıtlar sayfalara bölünür; sayfa başına 25, 50 veya 100 satır seçebilirsiniz. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
